<div class="card border-0 bg-danger text-white">
  <div class="card-body">
    <div class="d-flex flex-wrap align-items-center">
      <i class="fe fe-server font-size-50 mr-3"></i>
      <div>
        <div class="font-size-21 font-weight-bold">Databases</div>
        <div class="font-size-15">Total: 78,155</div>
      </div>
    </div>
  </div>
</div>